export default {
  getNapravlenie(competition) {
    let res = '';
    if (competition.competitionData?.is_bussines_area == 'true') {
      res = 'Бизнес-направление';
    } else {
      res = competition.napravlenie;
    }
    return res
  },
  getTourName($tourNumber) {
    let $tourName = '';
    if ($tourNumber == '1') {
      $tourName = 'Лонг-лист';
    } else if ($tourNumber == '0') {
      $tourName = 'Отборочный тур';
    } else if ($tourNumber == '2') {
      $tourName = 'Шорт-лист';
    } else if ($tourNumber == '3') {
      $tourName = 'Победители';
    }
    return $tourName;
  },
  isSummaryGrade(competitionId) {
    return competitionId === 137;
  }
}